import React from "react";
import styled, { css } from "styled-components";
import { navigate } from "gatsby-link";
import { truncate } from "../helpers";

const Wrapper = styled.div`
  padding: 1.5rem;
  background: white;
  border-radius: 5px;
  box-shadow: 0 2px 1px -1px hsl(0deg 0% 96%);

  display: flex;
  flex-direction: column;
  justify-content: space-between;

  .footer {
    margin-top: auto;
    display: flex;
    padding-top: 1rem;
    justify-content: space-between;
  }

  ${({ isClickable }) =>
    isClickable
      ? css`
          cursor: pointer;
          transition: all 0.3s;
          &:hover {
            box-shadow: 0 2px 1px 2px hsl(0deg 0% 94%);
            .title {
              color: hsl(0, 0%, 40%);
            }
          }

          .title {
            color: rgba(0, 0, 0, 0.85);
            transition: all 0.2s;
          }
        `
      : ""}
`;

const Title = styled.div`
  font-size: 19px;
  font-weight: 500;
  padding-bottom: 1rem;
`;

const Description = styled.div``;

const Tags = styled.div`
  color: hsl(0, 0%, 75%);
`;

export default function Card({
  title,
  description,
  link,
  footer = null,
  tags = [],
  isClickable = false,
  truncateLength = 200,
}) {
  return (
    <Wrapper
      isClickable={isClickable}
      onClick={
        isClickable && link
          ? (e) => {
              e.preventDefault();
              navigate(link);
            }
          : null
      }
    >
      <Title className="title">{title}</Title>
      <Description>
        <div
          dangerouslySetInnerHTML={{
            __html: truncate(description, truncateLength),
          }}
        />
      </Description>
      <div className="footer">
        <Tags>{tags.join(" | ")}</Tags>
        {footer}
      </div>
    </Wrapper>
  );
}
